import {inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);


  transform(value: string | undefined | null): SafeHtml | undefined {
    if (!value) {
      return undefined;
    }
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

}
